import React, { CSSProperties, RefObject } from 'react';

import Button from '../../library/button/button';
import { ArrowUpSolidIcon } from '../../shared/icons/icons';

import './back-to-top-button.scss';

interface BackToTopBtnProps {
  containerRef?: RefObject<HTMLDivElement>;
  onClick: () => void;
  styleObj: CSSProperties;
}

function BackToTopButton(props: BackToTopBtnProps) {
  const { containerRef, onClick, styleObj } = props;

  return (
    <div ref={containerRef} style={styleObj}>
      <Button onClick={onClick} styleName="button">
        <ArrowUpSolidIcon styleName="arrow" /> Top
      </Button>
    </div>
  );
}

export default BackToTopButton;
